import React from 'react';

export interface IIntoLogo {
  className?: string;
}

export default function IntoLogo({ className }: IIntoLogo) {
  return (
    <svg
      className={className}
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 137.01 34.81"
      aria-hidden="true"
    >
      <title>Into University Partnerships Logo</title>
      <path
        d="M40.34,64.67H33.2a.88.88,0,0,1-.87-.87V33.16a.84.84,0,0,1,.87-.83h7.14a.84.84,0,0,1,.87.83V63.8A.87.87,0,0,1,40.34,64.67Z"
        transform="translate(-32.33 -31.05)"
      />
      <path
        d="M72.94,64.67H67.11a2,2,0,0,1-1.83-1.18L56.71,48.92c-.18-.31-.31-.35-.44-.35s-.22.08-.22.39V63.8a.87.87,0,0,1-.87.87H48.66a.91.91,0,0,1-.92-.87V33.94a1.64,1.64,0,0,1,1.61-1.61H55.1c.82,0,1.3.48,1.74,1.27l8.83,15c.17.31.26.39.39.39s.22,0,.22-.39V33.2a.88.88,0,0,1,.87-.87h6.53a.88.88,0,0,1,.87.87V63.06A1.64,1.64,0,0,1,72.94,64.67Z"
        transform="translate(-32.33 -31.05)"
      />
      <path
        d="M100.18,39.56H93.7V63.8a.87.87,0,0,1-.87.87H85.74a.87.87,0,0,1-.87-.87V39.56H78.25a.84.84,0,0,1-.87-.83V33.16a.84.84,0,0,1,.87-.83h21.93a.88.88,0,0,1,.92.83v5.57A.88.88,0,0,1,100.18,39.56Z"
        transform="translate(-32.33 -31.05)"
      />
      <path
        d="M115.59,65.06c-7.22,0-13.36-3.7-13.36-14.32V46.26c0-10.62,6.14-14.36,13.36-14.36S129,35.64,129,46.26v4.48C129,61.36,122.82,65.06,115.59,65.06Zm4.4-18.8c0-4.66-1.35-6.57-4.4-6.57s-4.39,1.91-4.39,6.57v4.48c0,4.66,1.35,6.53,4.39,6.53s4.4-1.87,4.4-6.53Z"
        transform="translate(-32.33 -31.05)"
      />
      <path
        d="M151.93,65.87a17.41,17.41,0,1,1,17.41-17.41A17.4,17.4,0,0,1,151.93,65.87Zm0-32.21a14.8,14.8,0,1,0,14.8,14.8A14.78,14.78,0,0,0,151.93,33.66Zm1,16-6.49,7.74a1.78,1.78,0,0,1-2.48.22,1.74,1.74,0,0,1-.22-2.44l5.66-6.7-5.66-6.74a1.76,1.76,0,0,1,2.7-2.27L153,47.24a1.73,1.73,0,0,1,.48,1.22A1.9,1.9,0,0,1,153,49.68Zm9.14,0-6.49,7.74a1.78,1.78,0,0,1-2.48.22,1.73,1.73,0,0,1-.22-2.44l5.66-6.7-5.66-6.74a1.76,1.76,0,0,1,2.7-2.27l6.49,7.75a1.77,1.77,0,0,1,.48,1.22A2,2,0,0,1,162.12,49.68Z"
        transform="translate(-32.33 -31.05)"
      />
    </svg>
  );
}
